import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../../context/ThemeContext';

/**
 * ActivityStats component for displaying forum engagement metrics
 * Shows total questions, replies, and likes received in a responsive grid layout
 */
const ActivityStats = React.memo(({ stats }) => {
  const { isDarkMode } = useTheme();

  if (!stats) {
    return null;
  }

  const { totalQuestions = 0, totalReplies = 0, totalLikesReceived = 0 } = stats;

  return (
    <div className="grid grid-cols-3 gap-4 mb-6">
      {/* Questions Stat */}
      <div className="text-center">
        <div 
          className="text-2xl font-bold text-gray-900 dark:text-white"
          aria-label={`${totalQuestions} posts created`}
        >
          {totalQuestions}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Posts
        </div>
      </div>

      {/* Replies Stat */}
      <div className="text-center">
        <div 
          className="text-2xl font-bold text-gray-900 dark:text-white"
          aria-label={`${totalReplies} replies given`}
        >
          {totalReplies}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Replies
        </div>
      </div>

      {/* Likes Received Stat */}
      <div className="text-center">
        <div 
          className="text-2xl font-bold text-gray-900 dark:text-white"
          aria-label={`${totalLikesReceived} likes received`}
        >
          {totalLikesReceived}
        </div>
        <div className="text-xs text-gray-500 dark:text-gray-400">
          Likes Received
        </div>
      </div>
    </div>
  );
});

ActivityStats.displayName = 'ActivityStats';

ActivityStats.propTypes = {
  stats: PropTypes.shape({
    totalQuestions: PropTypes.number,
    totalReplies: PropTypes.number,
    totalLikesReceived: PropTypes.number
  })
};

export default ActivityStats;